import styled from "styled-components";

import { EditButton } from "shared/ui/buttons";
import { DateInput as BaseDateInput } from "shared/ui/inputs";

export const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 35px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const DateInput = styled(BaseDateInput)`
  border-radius: 1px;
  border: 2px solid var(--admin-gray-stroke, #e8e8e8);
  margin-left: 23px;
`;

export const DateInput1 = styled(DateInput)``;

export { DateInputDiv } from "shared/ui/layout";

export const HeaderBanner = styled.header`
  font-family: "Noto Sans KR";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`;

export const PBanner = styled.header`
  color: var(--admin-background, #1e1e2c);
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.56px;
  margin-left: 10px;
  margin-top: 10px;
`;

export const BlueSpan = styled.span`
  color: var(--admin-blue-default-blue, #0079e0);
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.56px;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.6000000238418579px;
  text-align: left;
`;

export const EditBtn = styled(EditButton)`
  width: fit-content;
  height: fit-content;
  padding: 5px 10px;
`;
